import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { DynamicFormField } from '@/common/form/formFields/DynamicFormField';
import { withConditionalRender } from '@/common/form/higherOrderComponents/withConditionalRender';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { TrxColFormField } from './formFields/TrxColFormField';

export const IncCondForm = () => {

  const rsrc = useRsrc();
  const { entityObj } = useEntityMgr();

  // const [pol, setPol] = useState();
  // const [incDataSrc, setIncDataSrc] = useState();
  // const [fieldTypes, setFieldTypes] = useState();
  const [trxCols, setTrxCols] = useState();

  const [loaded, setLoaded] = useState(false);
  useEffect(() => {    
    rsrc.data('gp', 'INC_COND_FORM_DATA_PLUGIN', { incRuleId: entityObj.incRuleId }).then(res => {
      // setPol(res.pol);
      // setIncDataSrc(res.incDataSrc);
      // setFieldTypes(res.fieldTypes);
      setTrxCols(res.trxCols);

      setLoaded(true);
    })
  }, [])

  if (!loaded) {
    return null;
  }

  const augFieldDefs = (fieldToFieldDef) => {
    const ValueFormField = withConditionalRender((formValues) => !['IS_ONE_OF', 'IS_NOT_ONE_OF'].includes(formValues.operator))(DynamicFormField);
    const IncListFormField = withConditionalRender((formValues) => ['IS_ONE_OF', 'IS_NOT_ONE_OF'].includes(formValues.operator))(DynamicFormField);
    
    fieldToFieldDef.value.component = <ValueFormField key="value" fieldDef={fieldToFieldDef.value} />
    fieldToFieldDef.incListId.component = <IncListFormField key="incListId" fieldDef={fieldToFieldDef.incListId} />

    fieldToFieldDef.trxCol.component = <TrxColFormField key="trxCols" trxCols={trxCols} fieldDef={fieldToFieldDef.trxCol} />
  }
  
  return (
    <EntityForm augFieldDefs={augFieldDefs}/>
  )
}